import React from 'react';
import { Link } from 'react-router-dom';
import '../../CSS/SuccessStoriesList.css';

const SuccessStoriesList: React.FC = () => {
  return (
    <div className="success-stories-list-page">
      {/* Dark Blue Banner */}
      <div className="success-stories-list-banner">
        <div className="success-stories-list-breadcrumb">
          <Link to="/">Home</Link>
          <span className="breadcrumb-separator">/</span>
          <Link to="/news-and-insights">News & Insights</Link>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-current">Our Success Stories</span>
        </div>
        <h1 className="success-stories-list-title">Our Success Stories</h1>
      </div>

      {/* White Content Area */}
      <div className="success-stories-list-content">
        {/* Tagline */}
        <div className="success-stories-list-tagline">
          <p>See the results. Real clients. Real growth. Read their stories.</p>
        </div>

        {/* Success Stories Cards */}
        <div className="list-of-success-stories-stories">
          <div className="success-stories-container">
            <div className="success-story-card">
              <div className="success-story-image-container">
                <img 
                  src="/assets/Web Version/Home Page/empowering-universities-success-story-image.png"
                  alt="Empowering Universities with AI-Driven Innovation"
                  className="success-story-image"
                />
              </div>
              <div className="success-story-content">
                <h3 className="success-story-title">Empowering Universities with AI-Driven Innovation</h3>
                <p className="success-story-description">
                  We partnered with a leading U.S. research university to establish a world-class AI Lab that bridges academic excellence with real-world industry innovation. The collaboration transformed the university's research ecosystem—embedding practical AI applications in healthcare, logistics, and retail—while creating a direct pipeline of skilled AI talent. research into real-world breakthroughs.
                </p>
                <Link to="/news-and-insights/our-success-stories/empowering-lead" className="success-story-button">
                  Read the full success story &gt;
                </Link>
              </div>
            </div>

            <div className="success-story-card">
              <div className="success-story-image-container">
                <img 
                  src="/assets/Web Version/Home Page/regional-internship-programs-success-story-image.png"
                  alt="Regional Internship Programs – Bridging Talent and Opportunity"
                  className="success-story-image"
                />
              </div>
              <div className="success-story-content">
                <h3 className="success-story-title">Regional Internship Programs – Bridging Talent and Opportunity</h3>
                <p className="success-story-description">
                  Our Regional Internship Program initiative has transformed how universities and employers collaborate to prepare the next generation of professionals. By aligning academic learning with real-world industry experience, the program has significantly improved job conversion rates and strengthened employer engagement across multiple regions.
                </p>
                <Link to="/news-and-insights/our-success-stories/regional-internship" className="success-story-button">
                  Read the full success story &gt;
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessStoriesList;

